export default [
  {name: '전체선택', value: 'READY,PROGRESS,FINISHED'},
  {name: '대기', value: 'READY'},
  {name: '진행중', value: 'PROGRESS'},
  {name: '완료', value: 'FINISHED'}
];
